// extracted by mini-css-extract-plugin
module.exports = {"readmeContainer":"about_readmeContainer__mVLOL","tvImage":"about_tvImage__31Tmg","purposeContainer":"about_purposeContainer__86AMB","howtoContainer":"about_howtoContainer__fcTqj"};